import { useMemo } from 'react';
import { PublicMoney } from '@guest-widgets/shared/src/types/product/miscellaneous';

import { TotalRowType, useTotal } from './useTotal';

interface UsePaymentResult {
  priceToPay: PublicMoney;
}

export const usePayment = (): UsePaymentResult => {
  const { totalRows } = useTotal();

  const priceToPay: PublicMoney = useMemo(() => {
    const amountToPayRow = totalRows.find((total) => total.type === TotalRowType.AMOUNT_TO_PAY);

    return {
      amount: amountToPayRow?.amount || 0,
      currencyCode: amountToPayRow?.currencyCode || 'EUR',
    };
  }, [totalRows.map((total) => total.amount).join(',')]);

  return {
    priceToPay,
  };
};
